import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  GLOBAL_CREATE_CATALOG,
  SIDEBAR_CATALOG,
} from "../app/newLayout/navigation/navigationCatalog";
import {
  filterGlobalCreateCatalog,
  filterSidebarCatalog,
  normalizeActiveModuleKeys,
} from "../app/newLayout/navigation/filterNavigationByActiveModules";
import { useGetOrganizationQuery } from "../store/apiSlice/accountApiSlice";
import { authUser } from "../store/slice/authSlice";
import { userBelongsToCompany } from "../utils/companyUser";

const CATALOG_BY_SURFACE = {
  sidebar: SIDEBAR_CATALOG,
  global_create: GLOBAL_CREATE_CATALOG,
};

export function useNavigationLayout(surface) {
  const user = useSelector(authUser);
  const catalog = CATALOG_BY_SURFACE[surface] || [];
  const hasCompany = userBelongsToCompany(user);

  const { data: organization, isLoading, isFetching } = useGetOrganizationQuery(undefined, {
    skip: !hasCompany,
  });

  const activeModuleKeys = useMemo(
    () => normalizeActiveModuleKeys(organization?.active_module_keys),
    [organization?.active_module_keys],
  );

  const items = useMemo(() => {
    if (surface === "sidebar") {
      return filterSidebarCatalog(catalog, activeModuleKeys);
    }
    if (surface === "global_create") {
      return filterGlobalCreateCatalog(catalog, activeModuleKeys);
    }
    return catalog;
  }, [activeModuleKeys, catalog, surface]);

  return {
    items,
    activeModuleKeys: [...activeModuleKeys],
    isLoading: hasCompany && (isLoading || isFetching),
    catalog,
  };
}
